import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";

const LS_KEY = "gatiq-last-org";

/**
 * At the root of the app, redirect a freshly-launched PWA to the org login
 * page it was installed from.
 *
 * The org-login page writes `gatiq-last-org` to `localStorage` while the user
 * is browsing. When the app opens as a standalone PWA window, this redirect
 * sends them back to `/:slug/login` so they land on the branded org sign-in —
 * not a blank home.
 *
 * Only fires when the app was launched in standalone mode; we do not hijack a
 * normal browser tab on every visit.
 */
export function PwaLaunchRedirect() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    // Only act on the root path — `start_url` is `/`.
    if (pathname !== "/") return;

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      // iOS Safari does not fire the media query — it writes an Apple web app
      // flag into the navigator instead.
      (navigator as { standalone?: boolean }).standalone;

    if (!isStandalone) return;

    const slug = localStorage.getItem(LS_KEY);
    if (slug) {
      navigate(`/${slug}/login`, { replace: true });
    }
  }, [navigate, pathname]);

  return null;
}